import React, {
    PropsWithChildren,
    ReactNode,
    useEffect,
    useRef,
} from 'react';
import clsx from 'clsx';
import {UseFormReturn} from 'react-hook-form/dist/types';
import {FormProvider} from 'react-hook-form';
import * as styles from './form.module.css';

interface FormColumnProps {
    className?: string,
    hasHalfWidth?: boolean,
    alignVertical?: 'center' | 'top' | 'bottom',
}

interface FormSubComponents {
    Row?: ReactNode,
    Column?: ReactNode,
    methods: UseFormReturn<Record<string, any>, object>,
}

const Form = ({children, methods}: PropsWithChildren<FormSubComponents>) => {
    const formRef = useRef<HTMLFormElement>(null);

    useEffect(() => {
        const form = formRef.current;

        if (!form) {
            return undefined;
        }

        const onSubmit = (e: Event) => {
            e.preventDefault();
        };

        form.addEventListener('submit', onSubmit);

        return () => {
            form.removeEventListener('submit', onSubmit);
        };
    }, []);

    return (
        <FormProvider {...methods}>
            <form ref={formRef} className={styles.form}>
                {children}
            </form>
        </FormProvider>
    );
};

const Row = ({children}: PropsWithChildren) => (
    <div className={styles.row}>
        {children}
    </div>
);

const Column = ({
    children,
    className,
    hasHalfWidth,
    alignVertical,
}: PropsWithChildren<FormColumnProps>) => (
    <div
        className={clsx(
            styles.column,
            hasHalfWidth && styles.halfWidth,
            styles[`vertical${alignVertical}`],
            className,
        )}
    >
        {children}
    </div>
);

Form.Row = Row;
Form.Column = Column;

export default Form;
